<!--补考列表-->
<template>
    <div class="el-MakeUpExamListInfo">
        <el-row class="page_content">
            <h1 class="head_title_white">
                <el-button type="primary" @click="$closePage()">关 闭</el-button>
            </h1>
            <div class="bg_"></div>
            <el-row style="padding: 20px;">
                <h1 style="margin-bottom:0">
                    {{ courseName }} 补考
                </h1>
                <el-row style="border-bottom:1px solid #f3f3f3;">
                    <div class="zy" v-for='(item,index) in examList' :key="index">
                        <h1>
                            {{ courseName }} 补考
                        </h1>
                        <p>剩余次数：{{ item.remainExamCount || 0 }} 次</p>
                        <p>补考限时：{{ item.examTimeLimit || 0 }} 分钟</p>
                        <div style="text-align: right;">
                            <el-button type="success" v-if="item.remainExamCount > 0" @click="ksks(item)">
                                {{ item.examStudentStateText }}
                            </el-button>
                            <el-button type="info" @click="ksjl(item.examId)">补考记录</el-button>
                        </div>
                    </div>
                </el-row>
                <el-row style="padding: 20px;" v-show="show_jl">
                    <h1 style="font-size: 20px;">您参加的《{{ courseName }}》补考情况如下：</h1>
                    <el-table
                        :data="tableData"
                        border
                        style="width: 100%;">
                        <el-table-column
                            prop="title"
                            header-align="center"
                            align="center"
                            label="补考次数">
                            <template slot-scope="scope">
                                第 {{ scope.$index + 1 }} 次
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="examStudentAddTime"
                            header-align="center"
                            align="center"
                            label="开考时间">
                        </el-table-column>
                        <el-table-column
                            prop="examFraction"
                            header-align="center"
                            align="center"
                            label="得分" width="200">
                            <template slot-scope="scope">
                                <el-link :underline="false" type="primary">{{ scope.row.examFraction }}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="totalScore"
                            header-align="center"
                            align="center"
                            label="总分" width="200">
                            <template slot-scope="scope">
                                <el-link :underline="false" type="danger">{{ scope.row.totalScore }}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="title"
                            header-align="center"
                            align="center"
                            label="操作" width="200">
                            <template slot-scope="scope">
                                <el-link :underline="false" :disabled="$isEmpty(scope.row.examFinishTime)"
                                         type="success" @click="viewAnswerSheet(scope.$index)">查看答卷
                                </el-link>
                                <!-- <el-link :underline="false" :disabled ="!$isEmpty(scope.row.examFinishTime)" type="success" style="margin-left:20px;" @click="continueTheExam(scope.$index)">继续补考</el-link> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
            </el-row>
        </el-row>
    </div>
</template>
<script>
import {getQueryVariable, getStorageKeyForRoleTag, openWithRoleTag} from "../../../common/ulit";

export default {
    name: "SchoolAssignment",
    data() {
        return {
            courseName: this.$Base64.decode(this.$route.query.courseName), //课程名称
            tePlanCourseId: this.$route.query.tePlanCourseId, //课程ID
            tableData: [], //补考记录List
            show_jl: false,
            onExamId: "",
            examList: [] //补考列表List
        };
    },
    created() {
        this.getMakeUpExamList();
        localStorage.removeItem(getStorageKeyForRoleTag('exam_tag'));
        let this_ = this;
        setInterval(function () {
            if (localStorage.getItem(getStorageKeyForRoleTag('exam_tag')) == 1) {
                localStorage.removeItem(getStorageKeyForRoleTag('exam_tag'));
                if (!this_.$isEmpty(this_.onExamId)) {
                    this_.ksjl(this_.onExamId);
                    this_.getMakeUpExamList(this_.onExamId);
                }
            }
        }, 1000);
    },
    methods: {
        getMakeUpExamList() { //获取补考列表
            this.$store.dispatch("user/getMakeUpExamList", {tePlanCourseId: this.tePlanCourseId}).then((ret) => {
                if (ret.code === 0 || ret.code === '0') {
                    // this.courseName = ret.courseName;
                    this.examList = ret.data;
                } else {
                    this.$message({
                        message: ret.msg,
                        type: 'warning'
                    });
                }
            });
        },
        ksks(item) {
            localStorage.setItem(getStorageKeyForRoleTag('examName_examination'), item.paperName);
            openWithRoleTag(window.location.origin + '/ExamInfo?examId=' + item.examId + '&pageType=bk');
        },
        ksjl(examId) {
            this.onExamId = examId;
            const loading = this.$loading({
                lock: true,
                text: '加载中......',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.show_jl = true;
            this.$store.dispatch("user/getMakeUpExamLog", {examId: examId}).then((ret) => {
                loading.close();
                if (ret.code === 0 || ret.code === '0') {
                    this.tableData = ret.data;
                } else {
                    this.$message({
                        message: ret.msg,
                        type: 'warning'
                    });
                }
            });
        },
        viewAnswerSheet(index) { //查看答卷
            // this.$router.push({name:'ViewAnswerSheet',query:{examStudentId:this.tableData[index].examStudentId}});
            openWithRoleTag(window.location.origin + '/ViewAnswerSheetExam?examStudentId=' + this.tableData[index].examStudentId);
        },
        continueTheExam(index) { //继续补考
            localStorage.setItem(getStorageKeyForRoleTag('examName_examination'), this.tableData[index].paperName + "   作业" + this.$chineseNum[index]);
            // this.$router.push({name:'Examination',query:{examId:this.tableData[index].examId}});
            openWithRoleTag(window.location.origin + '/Examination?examStudentId=' + this.tableData[index].examStudentId);
        }
    }
};
</script>
<style lang="less">
@import '../../../styles/base.less';

.el-MakeUpExamListInfo {
    .head_title_white {
        text-align: right;
        margin-bottom: 0;
        padding: 10px 30px;
    }

    .bg_ {
        height: 10px;
        background-color: @mainBg;
        margin: 0 -20px;
    }

    .learning_img {
        width: 280px;
        height: 220px;
        border: 1px solid rgb(238, 238, 238);
        float: left;
        margin-right: 20px;
    }

    .el-main {
        min-width: 1200px;
    }

    .zy {
        border: 1px solid rgb(164, 164, 255);
        width: 28%;
        height: 200px;
        border-radius: 10px;
        margin: 25px 1% 0 0;
        padding: 0 20px;
        float: left;
    }

    .odyContainer {
        height: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/learningCenter/exam/MakeUpExamList.vue